import React, { useContext } from "react"
import { GlobalAuthContext } from "../../context/authContext"

const SocialIcons = ({ contact }) => {
  const { state } = useContext(GlobalAuthContext)
  return (
    <ul className="social-icons-inline d-inline">
      {Object.keys(contact)?.map(value => {
        return state?.config?.social?.map(social => {
          if (social.name === value) {
            return (
              <li key={social.name} className="d-inline-block mr-2 social-icon">
                <a href={contact?.[value]} rel="noreferrer" target="_blank">
                  <span>
                    <i className={social.icon_name} />
                  </span>
                </a>
              </li>
            )
          }
          return null
        })
      })}
    </ul>
  )
}

export default SocialIcons
